export default "__VITE_PUBLIC_ASSET__3def5c39__"